import React, { useEffect, useMemo, useState } from 'react'

import { composerCertificat, PAGE } from './modeleCertificat'
import { mesureurCanevas, policePrete, FAMILLE } from './mesure'

import logoBlanc from '../../../images/logoBlanc-pdf.png'
import signatureBlanche from '../../../images/signature-nawal-blanche.png'

/* ⛔ CERTIFICAT DE REUSSITE, RENDU ECRAN.
   Dessine en SVG la composition de `modeleCertificat.js`, la meme que le PDF
   (`pdfCertificat.js`). Le SVG garde les proportions de la page A4 et se met
   a la largeur de son conteneur : net a toutes les tailles, telephone compris.
   Etape 2 (06/10/2026) : version noire seule ; affiche par
   `FenetreCertificat.js`, depuis la fin de module et « Mon résultat ».
   `dateDelivrance` absente : la date du jour, celle a laquelle le certificat
   serait telecharge (decision de Nawal). */

export const IMAGES_CERTIFICAT = {
  logo: logoBlanc,
  signature: signatureBlanche,
}

/* LES ELEMENTS D'UNE COMPOSITION, EN SVG (rect, trace, texte, image), dans
   le repere en mm de la page. Exporte le 07/10/2026 pour les apercus du bilan
   soft skills (Bilan/ApercuBilan.js) : un seul dessin a l'ecran pour les deux
   documents. Un texte qui porte `angle` (degres, sens inverse des aiguilles,
   comme dans le PDF) tourne autour de son point d'origine ; sans `angle`,
   rien ne change pour le certificat. */
export const ElementsComposition = ({ elements, images = {} }) => (elements || []).map((el, i) => {
  if (el.type === 'rect') {
    return <rect key={i} x={el.x} y={el.y} width={el.l} height={el.h} fill={el.couleur} data-role={el.role} />
  }
  if (el.type === 'trace') {
    const d = el.boucles.map((b) => 'M' + b.map(([x, y]) => x.toFixed(3) + ' ' + y.toFixed(3)).join('L') + 'Z').join('')
    return <path key={i} d={d} fill={el.couleur} fillRule="evenodd" data-role={el.role} />
  }
  if (el.type === 'texte') {
    return (
      <text
        key={i}
        x={el.x}
        y={el.y}
        fill={el.couleur}
        fontFamily={FAMILLE}
        fontSize={el.taille}
        fontWeight="400"
        letterSpacing={el.espacement || undefined}
        transform={el.angle ? `rotate(${-el.angle} ${el.x} ${el.y})` : undefined}
        data-role={el.role}
        style={{ fontKerning: 'none', whiteSpace: 'pre' }}
      >
        {el.texte}
      </text>
    )
  }
  if (el.type === 'image') {
    return <image key={i} href={images[el.source]} x={el.x} y={el.y} width={el.l} height={el.h} preserveAspectRatio="xMidYMid meet" data-role={el.role} />
  }
  return null
})

const CertificatReussite = ({ prenomNom, nomModule, dateDelivrance, langue = 'fr', exemple = false, style }) => {
  const [pret, setPret] = useState(false)
  useEffect(() => {
    let vivant = true
    policePrete().then(() => { if (vivant) setPret(true) })
    return () => { vivant = false }
  }, [])

  const composition = useMemo(() => (pret
    ? composerCertificat({ prenomNom, nomModule, dateDelivrance: dateDelivrance || new Date(), langue, exemple, mesurer: mesureurCanevas() })
    : null), [pret, prenomNom, nomModule, dateDelivrance, langue, exemple])

  return (
    <svg
      viewBox={`0 0 ${PAGE.largeur} ${PAGE.hauteur}`}
      width="100%"
      role="img"
      aria-label={[prenomNom, nomModule].filter(Boolean).join(', ')}
      data-certificat-reussite="noire"
      style={{ display: 'block', aspectRatio: `${PAGE.largeur} / ${PAGE.hauteur}`, ...style }}
    >
      {!composition && <rect x="0" y="0" width={PAGE.largeur} height={PAGE.hauteur} fill="#0A0A0B" />}
      {composition && <ElementsComposition elements={composition.elements} images={IMAGES_CERTIFICAT} />}
    </svg>
  )
}

export default CertificatReussite
